{
	"ariaDeleteHealingAdjustment": "Delete Healing Adjustment",
	"ariaHealingContextMenu": "Healing Context Menu",
	"delete": "Delete"
}
